import { Badge, Tooltip, cn } from '@skupreme/shared/ui';
import {
  getProviderSend,
  type ProviderSendOrder,
} from '../../lib/provider-send';

export type ProviderSendBadgeProps = {
  order: ProviderSendOrder | null | undefined;
  /** The list row's chip size; the detail card uses the default badge. */
  compact?: boolean;
  className?: string;
};

/**
 * EN-4544: on an Unfulfilled V2 row, whether the order already went to its
 * provider or still waits for an operator's Send. Nothing for a legacy order.
 */
export function ProviderSendBadge({
  order,
  compact,
  className,
}: ProviderSendBadgeProps) {
  const send = getProviderSend(order);

  if (!send) {
    return null;
  }

  return (
    <Tooltip placement="bottom start" content={send.hint}>
      <span
        className={cn(
          'sk:inline-flex sk:min-w-0 sk:max-w-full sk:cursor-default',
          className,
        )}
      >
        <Badge
          tone={send.tone}
          className={cn(
            'sk:max-w-full',
            compact && 'sk:text-xs sk:font-normal',
          )}
        >
          <span className="sk:truncate">{send.label}</span>
        </Badge>
      </span>
    </Tooltip>
  );
}
